import { rem } from "@certn/cascadia";
import {
  BasicButton,
  ModalTrigger,
  useMediaQuery,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";

import { LanguageModal } from "../../components/AppFooter/LanguageModal";
import { useLanguage } from "../../hooks/useLanguage";

export function LanguageSelector() {
  const { currentLanguageLabel } = useLanguage();
  const { mediaQuery } = useMediaQuery();

  return (
    <div
      className={css(
        mediaQuery({
          display: ["flex"],
          justifyContent: ["flex-end"],
          position: ["absolute"],
          top: [rem("space-3")],
          right: [rem("space-6")],
        })
      )}
    >
      <ModalTrigger
        trigger={() => (
          <BasicButton
            testID="change-language-button"
            leftIcon="language"
            size="small"
          >
            {currentLanguageLabel}
          </BasicButton>
        )}
      >
        {(close) => <LanguageModal onClose={close} />}
      </ModalTrigger>
    </div>
  );
}
